import React from "react";
import { cn } from "@gettactic/helpers";
import { Stack } from "@cmp-src/primitives";
import { Heading } from "@cmp-src/data-display/Heading/Heading";

export const WizardSectionStack: React.FC<
  React.PropsWithChildren<{ className?: string; title?: React.ReactNode }>
> = ({ children, className, title }) => {
  return (
    <Stack
      className={cn(
        "border-b border-b-neutral-100 px-6 pb-4 last:border-b-0",
        className
      )}
    >
      {title ? <Heading as="h3">{title}</Heading> : undefined}
      {children}
    </Stack>
  );
};
